import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'trialEndsTranslation',
})
export class TrialEndsTranslationPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(endDate: Date | string, startDate: Date | string = new Date()): string {
    if (!endDate) {
      return '';
    }
    const days = moment(endDate).diff(moment(startDate), 'days');
    if (days <= 0) {
      return this.translateService.instant('Trial ends today');
    } else if (days === 1) {
      return this.translateService.instant('Trial ends in {{remainingTrialDays}} day', {
        remainingTrialDays: 1,
      });
    } else {
      return this.translateService.instant('Trial ends in {{remainingTrialDays}} days', {
        remainingTrialDays: days,
      });
    }
  }
}
